import { get as _get } from 'lodash';

import jwtPayloadDecode from '../utilities/jwtPayloadDecode';

export const selectIsAuthorized = state => {
    const token = _get(state, 'firebase.auth.stsTokenManager.accessToken');
    try {
        const payload = jwtPayloadDecode(token);
        return Boolean(_get(payload, 'isAdmin'));
    } catch (e) {
        return false;
    }
};

export const selectIsAuthLoaded = state => _get(state, 'firebase.auth.isLoaded');
